export const CONNECTION_COLORS: { value: string; text: string }[] = [
  { value: "Rød", text: "Ikke koblet" },
  { value: "Gul", text: "Foreslåtte" },
  { value: "Grønn", text: "Bekreftede" },
];
